import { render, staticRenderFns } from "./PolicyEdit.vue?vue&type=template&id=52c4cd04&scoped=true&"
import script from "./PolicyEdit.vue?vue&type=script&lang=js&"
export * from "./PolicyEdit.vue?vue&type=script&lang=js&"
import style0 from "./PolicyEdit.vue?vue&type=style&index=0&id=52c4cd04&prod&lang=css&"
import style1 from "./PolicyEdit.vue?vue&type=style&index=1&id=52c4cd04&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c4cd04",
  null
  
)

export default component.exports